import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import ArrowDown from "rialto-icons/ArrowDown";

import styles from "./DropdownButton.css";

const DropdownButton = (props) => {
  const { children, color, icon, isFlat, isGreen, isLarge, label, onClick } = props;

  const Icon = icon;
  const btnClass = classNames(styles.root, {
    [styles.btn]: !children,
    [styles.flat]: isFlat,
    [styles.large]: isLarge,
    [styles.green]: isGreen,
  });

  return (
    <button
      className={btnClass}
      onClick={onClick}
      style={color && { color, borderColor: color, backgroundColor: "transparent" }}
      type="button"
    >
      {children ? (
        <div className={styles.content}>{children}</div>
      ) : (
        <div className={styles.content}>
          {icon && <Icon fill={color} size={isLarge ? "" : "small"} stroke={color} />}
          <div className={styles.label}>{label}</div>
        </div>
      )}
      <ArrowDown fill={color} size="small" stroke={color} />
    </button>
  );
};

DropdownButton.propTypes = {
  children: PropTypes.node,
  color: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  icon: PropTypes.func,
  isFlat: PropTypes.bool,
  isGreen: PropTypes.bool,
  isLarge: PropTypes.bool,
  onClick: PropTypes.func,
};

export default DropdownButton;
